var guestWishlistItemsCount_gql_default = `
query guestWishlistItemsCount($code: String!) {
  WmWishlist(sharing_code: $code) {
    items_count
  }
}
`;
export {
  guestWishlistItemsCount_gql_default as default
};
